export enum EFunnels {
  MAIN = 'main_page',

  PDF_CONVERTER = 'pdf_converter',
  PDF_TO_WORD = 'pdf_to_word',
  PDF_TO_PNG = 'pdf_to_png',
  PDF_TO_JPG = 'pdf_to_jpg',
  PDF_TO_EPUB = 'pdf_to_epub',
  PDF_TO_EXCEL = 'pdf_to_excel',
  PDF_TO_PPTX = 'pdf_to_pptx',
  PDF_TO_TEXT = 'pdf_to_text',

  IMAGE_TO_PDF = 'image_to_pdf',
  WORD_TO_PDF = 'word_to_pdf',
  PNG_TO_PDF = 'png_to_pdf',
  JPG_TO_PDF = 'jpg_to_pdf',
  EPUB_TO_PDF = 'epub_to_pdf',
  EXCEL_TO_PDF = 'excel_to_pdf',
  PPTX_TO_PDF = 'pptx_to_pdf',
  HEIC_TO_PDF = 'heic_to_pdf',
  JPG_TO_WEBP = 'jpg_to_webp',
  WEBP_TO_PNG = 'webp_to_png',
  WEBP_TO_JPG = 'webp_to_jpg',
  HEIC_TO_JPG = 'heic_to_jpg',
  JPG_TO_PNG = 'jpg_to_png',
  AVIF_TO_JPG = 'avif_to_jpg',
  SVG_TO_PNG = 'svg_to_png',
  AVIF_TO_PNG = 'avif_to_png',
  JFIF_TO_JPG = 'jfif_to_jpg',
  HTML_TO_PDF = 'html_to_pdf',
  PNG_TO_WEBP = 'png_to_webp',
  HEIC_TO_PNG = 'heic_to_png',
  ORGANIZE_PDF = 'organize_pdf',
  CSV_TO_EXCEL = 'csv_to_excel',
  DWG_TO_PDF = 'dwg_to_pdf',
  EXTRACT_PDF_PAGES = 'extract_pdf_pages',
  TEXT_TO_PDF = 'text_to_pdf',
  TIFF_TO_PDF = 'tiff_to_pdf',
  DJVU_TO_PDF = 'djvu_to_pdf',
  SVG_TO_JPG = 'svg_to_jpg',
  EPUB_TO_MOBI = 'epub_to_mobi',
  GIF_TO_PNG = 'gif_to_png',

  MERGE_PDF = 'merge_pdf',
  MERGE_IMAGES = 'merge_images',
  SPLIT_PDF = 'split_pdf',
  DELETE_PDF_PAGES = 'delete_pdf_pages',
  ROTATE_PDF = 'rotate_pdf',

  COMPRESS_PDF = 'compress_pdf',
  COMPRESS_IMAGES = 'compress_images',

  FILL_PDF = 'fill_pdf',
  EDIT_PDF = 'edit_pdf',
  SIGN_PDF = 'sign_pdf',
  CREATE_PDF = 'create_pdf',

  PDF_OCR = 'pdf_ocr',
  IMAGE_TO_TEXT = 'image_to_text',

  REMOVE_WATERMARK = 'remove_watermark',
  TRANSLATE_PDF = 'trsanslate_pdf',

  AI_SUMMARIZER = 'ai_summarizer'
}

export const EFunnelsSSE = [
  EFunnels.PDF_TO_WORD,
  EFunnels.PDF_TO_PNG,
  EFunnels.PDF_TO_JPG,
  EFunnels.PDF_TO_EPUB,
  EFunnels.PDF_TO_EXCEL,
  EFunnels.PDF_TO_PPTX,
  EFunnels.PDF_TO_TEXT,
  EFunnels.WORD_TO_PDF,
  EFunnels.EPUB_TO_PDF,
  EFunnels.EXCEL_TO_PDF,
  EFunnels.PPTX_TO_PDF,
  EFunnels.HEIC_TO_PDF,
  EFunnels.JPG_TO_WEBP,
  EFunnels.WEBP_TO_PNG,
  EFunnels.SPLIT_PDF,
  EFunnels.COMPRESS_PDF,
  EFunnels.COMPRESS_IMAGES,
  EFunnels.PDF_OCR,
  EFunnels.IMAGE_TO_TEXT,
  EFunnels.TRANSLATE_PDF
];
